import { Link } from "react-router-dom";
import { scrollToSection } from "@/lib/scroll";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative bg-[#060B18] border-t border-amber-500/15 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-10">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <p className="font-serif text-2xl font-semibold text-amber-50">Build Right Partners</p>
            <p className="mt-3 max-w-xs text-sm font-light leading-relaxed text-slate-400">
              Right Partner. Right Path. Right Growth. A California marketing agency for brands built to endure.
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-amber-500/70 mb-4">Navigate</p>
            <ul className="space-y-2.5 text-sm text-slate-300">
              {["services", "manifesto", "work", "testimonials", "contact"].map((s) => (
                <li key={s}>
                  <button
                    data-testid={`footer-link-${s}`}
                    onClick={() => scrollToSection(`#${s}`)}
                    className="capitalize hover:text-amber-300 transition-colors"
                  >
                    {s}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-amber-500/70 mb-4">Company</p>
            <ul className="space-y-2.5 text-sm text-slate-300">
              <li><Link data-testid="footer-link-blog" to="/blog" className="hover:text-amber-300 transition-colors">Insights (Blog)</Link></li>
              <li><Link data-testid="footer-link-pricing" to="/pricing" className="hover:text-amber-300 transition-colors">Pricing</Link></li>
              <li><Link data-testid="footer-link-team" to="/team" className="hover:text-amber-300 transition-colors">Team</Link></li>
              <li><Link data-testid="footer-link-careers" to="/careers" className="hover:text-amber-300 transition-colors">Careers</Link></li>
            </ul>
          </div>
          <div className="md:col-span-4">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-amber-500/70 mb-4">Locations</p>
            <ul className="space-y-2.5 text-sm text-slate-300">
              <li>Serving all of California</li>
              <li className="text-slate-400">SF · Silicon Valley · LA · San Diego · Sacramento</li>
              <li>
                <a href="mailto:sales@buildrightpartners.net" className="hover:text-amber-300 transition-colors" data-testid="footer-email-link">sales@buildrightpartners.net</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="gold-hairline mt-14" />

        <div className="mt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">
            © 2026 Build Right Partners. All rights reserved.
          </p>
          <Link
            data-testid="footer-admin-link"
            to="/admin"
            className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500 hover:text-amber-300 transition-colors"
          >
            Admin Portal
          </Link>
        </div>
      </div>

      <p
        aria-hidden="true"
        className="pointer-events-none select-none text-center font-serif font-bold leading-none text-stroke-gold text-[19vw] -mb-[6vw]"
      >
        BUILD RIGHT
      </p>
    </footer>
  );
};
